import gql from 'graphql-tag';

// Draft counterpart of setPageV2Css. `pages.v2_css` is publish-only truth (the
// five publish callers write it); `pages.v2_css_draft` is written ONLY by the
// preview rebuild in ModalPreviewPage.vue. The published runtime reader in
// files/_app_dev/js/lib.file.js reads `v2_css`, the preview reader reads
// `v2_css_draft` — so a draft can never reach a live visitor.
export default gql`
mutation setPageV2CssDraft(
  $pageId: Int!,
  $v2CssDraft: String
) {
  update_pages_by_pk(
    pk_columns: { page_id: $pageId },
    _set: { v2_css_draft: $v2CssDraft }
  ) {
    page_id
  }
}
`;
